// extracted by mini-css-extract-plugin
export default {"root":"SubMenu_root__pdcbu","active":"SubMenu_active__Rt3Ld","header":"SubMenu_header__0JqXy","navMenu":"SubMenu_navMenu__6Kf5z","navMenuItem":"SubMenu_navMenuItem__Vx5SV"};